import { AchNoticeStatusDto } from '@/models/suba/ach-notice/ach-notice-status-dto.model';
import { ApiService } from '@/services/Api.service';

export class AchNoticeService {
  static async getStatus() {
    return ApiService.getJson<AchNoticeStatusDto>(`/ach-notice/status`);
  }

  static async upload(file: File) {
    const formData = new FormData();
    formData.append('csvFile', file, file.name);

    return ApiService.postFormData<string>(`/ach-notice`, formData);
  }
}
